"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fourteen/sections/servicesSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServicesSectionServicesFourteenFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" | "3s" | "4s" */
    dataWowDuration: string;
    /** Detected variants: "Acne Treatment" | "Anti Aging Care" | "Cosmetic Procedures" | "Laser Therapy" */
    h30Text: ReactNode;
    /** Detected variants: "Evidence-based solutions for clearer, healthier skin at any age" | "Advanced cosmetic solutions for radiant, flawless skin" | "Laser therapy for acne scars and skin tightening" */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/service/service-thumb-01.jpg" | "/Templates/Doccure/img/service/service-thumb-02.jpg" | "/Templates/Doccure/img/service/service-thumb-03.jpg" | "/Templates/Doccure/img/service/service-thumb-04.jpg" */
    src: string;
    /** Detected variants: "/Templates/Doccure/img/service/service-lg-01.jpg" | "/Templates/Doccure/img/service/service-lg-02.jpg" | "/Templates/Doccure/img/service/service-lg-03.jpg" | "/Templates/Doccure/img/service/service-lg-04.jpg" */
    imageWithBasePath1Src: string;
    /** Detected variants: "Acne Treatment" | "Anti Aging Care" | "Cosmetic Procedures" | "Laser Therapy" */
    h30H30Text: ReactNode;
    /** Detected variants: "services-item-fourteen wow fadeInUp" */
    className?: string;
    /** Detected variants: "services-info" */
    div0ClassName?: string;
    /** Detected variants: "services-content" */
    div0ClassName2?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "view-icon" */
    link0ClassName?: string;
    /** Detected variants: "all_routes.speciality" */
    href?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
    /** Detected variants: "services-profile" */
    div1ClassName?: string;
    /** Detected variants: "services" */
    alt?: string;
    /** Detected variants: "img-fluid thumb-img" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "services" */
    imageWithBasePath1Alt?: string;
    /** Detected variants: "img-fluid large-img" */
    imageWithBasePath1ClassName?: string;
    /** Detected variants: "title" */
    h30ClassName2?: string;
};
export type HomeFourteenServicesSectionGeneratedProps = {
    divDiv0Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServicesSectionServicesFourteenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    divDiv0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServicesSectionServicesFourteenFadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSectionServicesFourteenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv1ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSectionServicesFourteenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServicesSectionServicesFourteenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Medical" */
    sectionDiv0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Dermatology" */
    sectionDiv0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "to Aesthetic Treatments" */
    sectionDiv0Div0Div0H20Span1SpanText?: ReactNode;
    /** Default: "all_routes.register" */
    sectionDiv0Div0Link0LinkHref?: string;
    /** Default: "View All Services" */
    sectionDiv0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/team-bg-02.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    servicesSectionServicesFourteenFadeInUps: ServicesSectionServicesFourteenFadeInUpsItem[];
    servicesSectionServicesFourteenFadeInUpsItemWrapper?: (item: ServicesSectionServicesFourteenFadeInUpsItem, content: ReactNode) => ReactNode;
    servicesSectionServicesFourteenFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    servicesSectionServicesFourteenFadeInUpsLinkVisible?: boolean;
    servicesSectionServicesFourteenFadeInUpsLinkRenderer?: (item: ServicesSectionServicesFourteenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionServicesFourteenFadeInUpsImageVisible?: boolean;
    servicesSectionServicesFourteenFadeInUpsImageRenderer?: (item: ServicesSectionServicesFourteenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionServicesFourteenFadeInUpsH3Visible?: boolean;
    servicesSectionServicesFourteenFadeInUpsH3Renderer?: (item: ServicesSectionServicesFourteenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionServicesFourteenFadeInUpsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServicesSectionServicesFourteenFadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    servicesSectionServicesFourteenFadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSectionServicesFourteenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    servicesSectionServicesFourteenFadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: ServicesSectionServicesFourteenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeFourteenServicesSectionGenerated: FC<HomeFourteenServicesSectionGeneratedProps> = ({
    sectionDiv0Div0Div0H20H2Text = "Medical",
    sectionDiv0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0H20H2Props,
    sectionDiv0Div0Div0H20Span0SpanText = "Dermatology",
    sectionDiv0Div0Div0H20Span1SpanText = "to Aesthetic Treatments",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Link0LinkHref = "all_routes.register",
    sectionDiv0Div0Link0LinkText = "View All Services",
    sectionDiv0Div0Link0LinkVisible,
    sectionDiv0Div0Link0LinkRenderer,
    sectionDiv0Div0Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/team-bg-02.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0H30H3Props,
    divDiv0Link0LinkProps,
    divDiv1ImageWithBasePath0ImageProps,
    divDiv1ImageWithBasePath1ImageProps,
    divH30H3Props,
    servicesSectionServicesFourteenFadeInUps,
    servicesSectionServicesFourteenFadeInUpsItemWrapper,
    servicesSectionServicesFourteenFadeInUpsRenderer,
    servicesSectionServicesFourteenFadeInUpsLinkVisible,
    servicesSectionServicesFourteenFadeInUpsLinkRenderer,
    servicesSectionServicesFourteenFadeInUpsImageVisible,
    servicesSectionServicesFourteenFadeInUpsImageRenderer,
    servicesSectionServicesFourteenFadeInUpsH3Visible,
    servicesSectionServicesFourteenFadeInUpsH3Renderer,
    servicesSectionServicesFourteenFadeInUpsLinkProps,
    servicesSectionServicesFourteenFadeInUpsImageProps,
    servicesSectionServicesFourteenFadeInUpsH3Props,
}) => {
    return (
        <section className="services-section-fourteen section">
            <div className="container">
                <div className="section-header section-header-fourteen title-white section-btn wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div>
                        {renderNode(sectionDiv0Div0Div0H20H2Visible, sectionDiv0Div0Div0H20H2Renderer, (
                            <h2 className="section-title" {...(sectionDiv0Div0Div0H20H2Props ?? {})}>
                                {sectionDiv0Div0Div0H20H2Text}
                                <span className="section-line">{sectionDiv0Div0Div0H20Span0SpanText}</span>
                                {" "}
                                <span className="subtitle">{sectionDiv0Div0Div0H20Span1SpanText}</span>
                            </h2>
                        ))}
                    </div>
                    {renderNode(sectionDiv0Div0Link0LinkVisible, sectionDiv0Div0Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div0Link0LinkHref} className="btn btn-secondary theme-14-btn" {...(sectionDiv0Div0Link0LinkProps ?? {})}>
                            <i className="isax isax-bubble5 me-2" />
                            {sectionDiv0Div0Link0LinkText}
                        </SmartLink>
                    ))}
                </div>
                <div className="services-content-fourteen d-flex gap-4">
                    {renderCollectionNode(
                        servicesSectionServicesFourteenFadeInUps,
                        (item: ServicesSectionServicesFourteenFadeInUpsItem) => (
                            <div className={item.className ?? "services-item-fourteen wow fadeInUp"} data-wow-duration={item.dataWowDuration} key={item.key}>
                                {renderItemNode(servicesSectionServicesFourteenFadeInUpsH3Visible, servicesSectionServicesFourteenFadeInUpsH3Renderer, item, (
                                    <h3 className={item.h30ClassName2 ?? "title"} {...(typeof servicesSectionServicesFourteenFadeInUpsH3Props === "function" ? servicesSectionServicesFourteenFadeInUpsH3Props(item) : (servicesSectionServicesFourteenFadeInUpsH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>{item.h30H30Text}</h3>
                                ))}
                                <div className={item.div0ClassName ?? "services-info"}>
                                    <div className={item.div0ClassName2 ?? "services-content"}>
                                        {renderItemNode(servicesSectionServicesFourteenFadeInUpsH3Visible, servicesSectionServicesFourteenFadeInUpsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof servicesSectionServicesFourteenFadeInUpsH3Props === "function" ? servicesSectionServicesFourteenFadeInUpsH3Props(item) : (servicesSectionServicesFourteenFadeInUpsH3Props ?? {}))} {...(typeof divDiv0Div0H30H3Props === "function" ? divDiv0Div0H30H3Props(item) : (divDiv0Div0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                    {renderItemNode(servicesSectionServicesFourteenFadeInUpsLinkVisible, servicesSectionServicesFourteenFadeInUpsLinkRenderer, item, (
                                        <SmartLink href={item.href ?? "all_routes.speciality"} className={item.link0ClassName ?? "view-icon"} {...(typeof servicesSectionServicesFourteenFadeInUpsLinkProps === "function" ? servicesSectionServicesFourteenFadeInUpsLinkProps(item) : (servicesSectionServicesFourteenFadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Link0LinkProps === "function" ? divDiv0Link0LinkProps(item) : (divDiv0Link0LinkProps ?? {}))}>
                                            <i className={item.i0ClassName ?? "isax isax-arrow-right-1"} />
                                        </SmartLink>
                                    ))}
                                </div>
                                <div className={item.div1ClassName ?? "services-profile"}>
                                    {renderItemNode(servicesSectionServicesFourteenFadeInUpsImageVisible, servicesSectionServicesFourteenFadeInUpsImageRenderer, item, (
                                        <SmartImage src={item.src} alt={item.alt ?? "services"} className={item.imageWithBasePath0ClassName ?? "img-fluid thumb-img"} {...(typeof servicesSectionServicesFourteenFadeInUpsImageProps === "function" ? servicesSectionServicesFourteenFadeInUpsImageProps(item) : (servicesSectionServicesFourteenFadeInUpsImageProps ?? {}))} {...(typeof divDiv1ImageWithBasePath0ImageProps === "function" ? divDiv1ImageWithBasePath0ImageProps(item) : (divDiv1ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                    {renderItemNode(servicesSectionServicesFourteenFadeInUpsImageVisible, servicesSectionServicesFourteenFadeInUpsImageRenderer, item, (
                                        <SmartImage src={item.imageWithBasePath1Src} alt={item.imageWithBasePath1Alt ?? "services"} className={item.imageWithBasePath1ClassName ?? "img-fluid large-img"} {...(typeof servicesSectionServicesFourteenFadeInUpsImageProps === "function" ? servicesSectionServicesFourteenFadeInUpsImageProps(item) : (servicesSectionServicesFourteenFadeInUpsImageProps ?? {}))} {...(typeof divDiv1ImageWithBasePath1ImageProps === "function" ? divDiv1ImageWithBasePath1ImageProps(item) : (divDiv1ImageWithBasePath1ImageProps ?? {}))} />
                                    ))}
                                </div>
                            </div>
                        ),
                        servicesSectionServicesFourteenFadeInUpsItemWrapper,
                        servicesSectionServicesFourteenFadeInUpsRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid service-bg" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFourteenServicesSectionGenerated;
